/**
 * STUDENT DETAILS Reducers
 */
import {
  STUDENT_DETAILS_ACTION,
  GET_STUDENT_DETAILS,
  } from 'Actions/types';
  
  const INIT_STATE = {
    studentdownloadlist: [],
    loading: false,
  };
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case STUDENT_DETAILS_ACTION:
        return { ...state, loading: true };
  
      case GET_STUDENT_DETAILS:
        return { ...state, loading: false, studentdownloadlist: action.payload };
  
      default:
        return { ...state };
    }
  };
  
  